export default function RequiredAsterisk({
  required = false
}: {
  required?: boolean
}) {
  return <>{required && <span className="required-asterisk">*{" "}</span>}</>
}
